import React, { useContext, useState } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "../services/UserContext";
import { useClient } from "../services/ClientContext";
import brandIcon from "../assets/brand/icon.png";
import brandLogo from "../assets/brand/logo.png";
import "./sidebar.css";

const ITEMS = [
  {
    label: "Calendario",
    path: "/",
    modulo: "calendario",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    label: "Pacientes",
    path: "/pacientes",
    modulo: "pacientes",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    label: "Profesionales",
    path: "/profesionales",
    modulo: "profesionales",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
        <line x1="12" y1="6" x2="12" y2="6.01" strokeWidth="3" strokeLinecap="round" />
        <path d="M10 6 Q12 4 14 6" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    label: "Finanzas",
    path: "/finanzas",
    modulo: "finanzas",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
  },
  {
    label: "Configuracion",
    path: "/configuracion",
    modulo: "configuracion",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 0-.33 1V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-.33-1A1.65 1.65 0 0 0 8 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-.6-1 1.65 1.65 0 0 0-1-.33H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1-.33A1.65 1.65 0 0 0 4.6 8a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 8 4.6a1.65 1.65 0 0 0 1-.6 1.65 1.65 0 0 0 .33-1V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 .33 1 1.65 1.65 0 0 0 1 .6 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 8c.14.32.2.67.2 1a1.65 1.65 0 0 0 .6 1 1.65 1.65 0 0 0 1 .33H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1 .33 1.65 1.65 0 0 0-.51.34z" />
      </svg>
    ),
  },
];

const logoutIcon = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, setUser } = useContext(UserContext);
  const { modulos } = useClient();
  const [expanded, setExpanded] = useState(false);

  const visibleItems = ITEMS.filter((item) => modulos[item.modulo]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  // Bottom bar para mobile: se monta via Portal en document.body
  // para que nunca quede atrapada dentro del layout de la página.
  const mobileBar = (
    <nav className="mobile-bottom-bar">
      {visibleItems.map((item) => (
        <button
          key={item.path}
          className={`mobile-tab-btn ${isActive(item.path) ? "active" : ""}`}
          onClick={() => navigate(item.path)}
        >
          <span className="mobile-tab-icon">{item.icon}</span>
          <span className="mobile-tab-label">{item.label}</span>
        </button>
      ))}
      <button className="mobile-tab-btn" onClick={handleLogout}>
        <span className="mobile-tab-icon">{logoutIcon}</span>
        <span className="mobile-tab-label">Salir</span>
      </button>
    </nav>
  );

  return (
    <>
      {/* ── SIDEBAR DESKTOP (lateral colapsable) ── */}
      <aside
        className={`sidebar ${expanded ? "expanded" : ""}`}
        onMouseEnter={() => setExpanded(true)}
        onMouseLeave={() => setExpanded(false)}
      >
        <div className="sidebar-header">
          {expanded ? (
            <img
              src={brandLogo}
              alt="TurnoOnline.com Odontología"
              className="sidebar-logo-img sidebar-logo-img--full"
            />
          ) : (
            <img
              src={brandIcon}
              alt="TurnoOnline"
              className="sidebar-logo-img sidebar-logo-img--icon"
            />
          )}
        </div>

        <nav className="sidebar-nav">
          {visibleItems.map((item) => (
            <button
              key={item.path}
              className={`sidebar-nav-btn ${isActive(item.path) ? "active" : ""}`}
              onClick={() => navigate(item.path)}
              title={item.label}
            >
              <span className="sidebar-nav-icon">{item.icon}</span>
              {expanded && <span className="sidebar-nav-label">{item.label}</span>}
            </button>
          ))}
        </nav>

        <button
          className="sidebar-logout-btn"
          onClick={handleLogout}
          title="Cerrar sesión"
        >
          <span className="sidebar-nav-icon">{logoutIcon}</span>
          {expanded && <span className="sidebar-nav-label">Salir</span>}
        </button>
      </aside>

      {/* ── BOTTOM BAR MOBILE (portal directo al body) ── */}
      {ReactDOM.createPortal(mobileBar, document.body)}
    </>
  );
}
